import {
  ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {ProductService} from "../shared/product.service";
import {ContactData} from "../+contacts/contact.schema";
import {ApiService} from "../shared/api.service";
import {ContactService} from "../shared/contact.service";

declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'products',
  styles: [ require('./products.component.css') ],
  template: require('./products.component.html')
})
export class ProductsComponent implements OnInit {

  isBrowser: boolean;
  isNavOpened: boolean = false;
  activeImage: string;
  showVideo: boolean;
  products: any;
  selectedProduct: any;
  activeTab: string;
  contactData: ContactData;
  captcha: string;

  constructor(@Inject('isBrowser') isBrowser: boolean, private productService: ProductService, private contactService: ContactService){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {
    this.products = this.productService.getProducts();
    this.activeTab = 'product';
  }

  @ViewChild("productModalDiv") productModalDiv: ElementRef;

  toggleNavigation(){
    this.isNavOpened = !this.isNavOpened;
    $("#productNav").show().css("display", this.isNavOpened ? "flex" : "none");
  }

  getCaptcha(){
    this.contactService.getCaptcha()
      .subscribe(res => this.captcha = res);
  }

  onSelect(product: any){
    this.selectedProduct = this.productService.getProduct(product.id);
    this.setActiveImage(this.selectedProduct.image1);
    this.activeTab = 'product';
    this.openModal();
  }

  //open modal dialog
  openModal(){
    this.getCaptcha();
    $(".modal-content").show();
    $(".message-wrapper").hide();
    $(this.productModalDiv.nativeElement).modal('show');
    this.contactData = new ContactData(); 
  }

  //close modal dialog
  closeModal(){
    $(this.productModalDiv.nativeElement).modal('hide');
  }

  setActiveImage(imageName:string){
    this.activeImage = imageName;
  }

  sendContact(){
    this.contactData.product = this.selectedProduct.id;
    this.contactService.sendContact(this.contactData)
      .subscribe(res => {
        this.contactData = new ContactData();
        this.captcha = res.captcha;
        $(".modal-content").hide();
        $(".message-wrapper").css("display", "flex");
        setTimeout(() =>{
            this.closeModal();
        }, 2000);
      });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+products/products.component.ts